export default {
    bms : {
        title : 'Bare Metal Server',
        common : {
            search : 'Search',
            location : 'Location',
            element1 : 'Select region to filter',
            element2 : 'No data found, you can',
            content : 'create an instance',
            Intranet : 'Intranet',
            Pending : 'Pending',
            month : 'mo',
            buybms : 'Purchase BMS',
            buyip : 'Purchase IP',
            createsevergroup : 'Create Security Group',
            createintnet : 'Create Intranet',
            copy:'Copy',
        },
        list : {
            FirstList : 'Instances',
            SecondList : 'Security Groups',
            ThirdList : 'IP',
            FourthList : 'Intranets',
            SecurityGroupstitle : 'Security Groups - Bare Metal Server',
            IPtitle : 'IP - Bare Metal Server',
            Intranetstitle : 'Intranets - Bare Metal Server',
        },
        Instances : {
            searchHolder : 'Search for Instance ID / Name / IP',
            FirstColumn  : 'Instance ID / Name / IP',
            SecondColumn : 'Specifications',
            ThirdColumn : 'OS',
            FourthColumn : 'Zone',
            FifthColumn : 'Creation Time',
            SixthColumn : 'Expiration Time',
            SeventhColumn : 'Price ($ / mo)',
            EighthColumn : {
                title : 'Status',
                Unlisted : 'Unlisted',
                Initializing : 'Initializing',
                Running : 'Running',
                Reinstalling : 'Reinstalling',
                ConfigChanging : 'Config Changing',
                Disconnected : 'Disconnected',
                Stopped : 'Stopped',
                // Discontinued : 'Discontinued',
                ZoneChanging : 'Zone Changing',
                Unknown : 'Unknown Status'
            },
            NinthColumn : {
                title : 'Actions',
                Renew : 'Renew',
                View  : 'View',
                Rename : 'Rename',
                Start : 'Start',
                Restart : 'Restart',
                Stop : 'Stop',
                Upgrade : 'Upgrade', 
                Upgradebandwidth : 'Upgrade Bandwidth', 
                UpgradeTemBandwidth : 'Temporary Bandwidth',  
                Reinstall : 'Reinstall',
                AddReservedIP : 'Add Reserved IP',
                AddDataDisk : 'Add Data Disk',
                AddtoIntranet : 'Add to Intranet'
            },
            renewpop : {
                title : 'Renew',
                element1 : '',
                element2 : 'Summary',
                element3 : 'Public IP Address(es)',
                element4 : 'instance selected',
                element5 : 'instances selected',
                Duration : 'Duration',
                element1month : '1 Month',
                element2months : '2 Months',
                element3months : '3 Months',
                element6months : '6 Months',
                element1year : '1 Year',
                element2years : ' 2Years',
                Balance : 'Balance',
                Password : 'Password',
                element6 : 'Please enter the login password',
                Charges : 'Price',
                Button1 : 'Cancel',
                Button2 : 'Pay',
            },
            Viewlist : {
                title:'View',
                Information : {
                   title : 'Basic Information',
                   element1 : 'Bare Metal Server Information',
                   User : 'User',
                   OrderNo : 'Order No',
                   InstanceID : 'Instance ID',
                   Zone : 'Zone',
                   Charges : 'Price',
                   Bandwith : 'Bandwith',
                   Status : 'Status',
                   OSCategory : 'OS Category',
                   OSVersion : 'OS Version',
                   SystemDisk : 'System Disk',
                   CreatedTime : 'Creation Time',
                   ExpiredTime : 'Expiration Time',
                   PublicIP : 'Public IP',
                   element2 : 'Hard Disk Information',
                   Model : 'Model',
                   UsageStatus:  'Status',
                   Enabled : 'Enabled',
                   Disabled : 'Disabled',
                   Wait : 'Initializing, please wait.'
                },
                Monitoring : {
                    title : 'Monitoring',
                    BandwidthMonitoring : 'Bandwidth Monitoring',
                    Interval1minute : 'Interval 1 minute',
                    Receive : 'Receive',
                    SentOut : 'Sent',
                    element1day :  '1 day',
                    element1hour :  '1 hour',
                    element30min :  '30 min',
                    element10min :  '10 min',
                },
                OperationRecords : {
                    title : 'Operation Records',
                    ActionName : 'Operation Name',
                    UserName : 'User Name',
                    IPAddress : 'IP Address',
                    OccurredAt : 'Operation Time',
                }
            },
            renamepop : {
                title : 'Rename',
                newname : 'New Name: ',
                Button1 : 'Cancel',
                Button2 : 'Rename',
                element1 :'Please enter a new Name here'
            },
            startpop : {
                title : 'Start',
                element1 : '',
                element2 : 'instance selected',
                element3 : 'instances selected',
                element4 : 'Startable',
                element5 : 'Not Startable',
                Button1 : 'Cancel',
                Button2 : 'Start',
            },
            restartpop : {
                title : 'Restart',
                element1 : '',
                element2 : 'Forced Stop may result in data loss or file system corruption. Use only it when the server cannot be shut down normally.',
                element3 : 'Confirm to force restart.',
                element4 : 'instance selected',
                element5 : 'instances selected',
                element6 : 'Restartable',
                element7 : 'Not Restartable',
                Button1 : 'Cancel',
                Button2 : 'Restart',
            },
            stoppop : {
                title : 'Stop',
                element1 : '',
                element2 : 'Sure to stop the server? During the shutdown, the host will not be able to provide service normally, please be prepared to avoid any impact.',
                element3 : 'Forced stop may result in data loss or file system corruption. Use only it when the server cannot be shut down normally.',
                element4 : 'Confirm to force a stop.',
                element5 : 'instance selected',
                element6 : 'instances selected',
                element7 : 'Stoppable',
                element8 : 'Not Stoppable',
                Button1 : 'Cancel',
                Button2 : 'Stop',
            },
            upgradebandwidthpop : {
                title : 'Upgrade Bandwidth',
                CurrentConfiguration:  'Current Configuration:',
                PermanentBandwidth:  'Permanent Bandwidth:',
                Temporary:  'Temporary',
                element1 : 'After expiration date , the renewal fee of next billing cycle is',
                element2 : 'Bandwidth upgrade takes effect in real time',
                element3 : 'Please enter the login password',
                Balance : 'Balance',
                Password : 'Password',
                Charges : 'Price',
                Button1 : 'Cancel',
                Button2 : 'Pay',
            },
            upgradetembandwidthpop : {
                title : 'Buy Temporary Bandwidth',
                CurrentBandwidth: 'Current Bandwidth:',
                BandwidthIncrement : 'Bandwidth Increment:',
                Temporary:  'Temporary',
                Duration : 'Duration:',
                Hour : 'Hour',
                Day : 'Day',
                Hour_s : 'Hour(s)',
                Day_s : 'Day(s)',
                Hours : 'Hours',
                Days : 'Days',
                Password : 'Password',
                element1 : 'Please enter the login password',
                Charges : 'Price',
                Button1 : 'Cancel',
                Button2 : 'Pay',
            },
            reinstallpop : {
                title : 'Reinstall Operating System',
                element1 : 'Select Image:',
                element2 : 'OS',
                element3 : 'Select',
                element4 : 'Remote Account',
                user : 'user',
                password : 'password',
                element5 : 'The password must be 8 to 16 characters in length and must contain uppercase and',
                element6 : 'lowercase letters and digits while special symbols are not supported.',
                element7 : 'After reinstallation, all data in the system disk will be cleared and restored to the initial state.',
                element8 : 'Data disk purchased separately needs to be mouted manually before it can be used.',
                Button1 : 'Cancel',
                Button2 : 'Reinstall',
            },
            addReservedIPpop : {
                title : 'add Reserved IP',
                element1 : 'Sure to add IP for',
                element2 : '',
                element3 : 'Quantity (1~10):',
                element4 : 'Adjusted Config',
                CurrentIP : 'Current IP',
                GoalIP : 'Goal IP',
                ValidityPeriod : 'Validity Period',
                element5 : 'After expiration date ',
                element6 : 'the renewal fee of next billing cycle',
                element7 : 'Each physical machine has at least 1 public IP address.',
                element8 : 'Please enter the login password',
                Balance : 'Balance',
                Password : 'Password',
                Charges : 'Price',
                Button1 : 'Cancel',
                Button2 : 'Pay',
            },
            addDataDiskpop : {
                title : 'Add Data Disk',
                element1 : 'Sure to add a hard drive fo',
                element2 : '',
                element3 : 'Quantity (1~10):',
                element4 : 'Hard Disk Type:',
                element5 : 'After expiration date ',
                element6 : 'the renewal fee of next billing cycle is',
                element7 : 'The hard drive will be manually added by the personnel after purchase, which costs about 10 to 30 minutes.',
                element8 : 'The hard drive needs to be mounted on the system before it can be seen and used.',
                element9 : 'Please enter the login password',
                Balance : 'Balance',
                Password : 'Password',
                Charges : 'Price',
                Button1 : 'Cancel',
                Button2 : 'Pay',
            },
            addtoIntranetpop : {
                title : 'Add to Intranet',
                Instance : 'Instance',
                PublicIP : 'Public IP',
                element1 : 'Select an Intranet: ',
                element2 : 'Instances in the same zone can communicate via internal IP.',
                element3 : 'No Security Intranet, please ',
                element4 : 'create one',
                Button1 : 'Cancel',
                Button2 : 'Add',
            },
            addseverpop : {
                title : 'Add to security group',
                element1 : 'Select Security Group',
                element2 : 'Please select a security group',
                element3 : 'Selected instance: ',
                element4 : '',
                element5 : 'instances selected',
                element6 : 'joinable',
                element7 : 'Not joinable',
                element8 : ' After joining, the rules of the selected security group will take effect automatically for the selected instances.',
                element9 : 'Add to security group for the first time, all ports are rejected by default, please add permission policy rules as needed.',
                element10 : 'No Security Group, please',
                element11 : 'create one',
                Button1 : 'Cancel',
                Button2 : 'Add',
            },
            footer : {
                title : 'Mass Actions',
                Renew : 'Renew',
                AddtoSecurityGroup : 'Add to Security Group',
                Start : 'Start',
                Restart : 'Restart',
                Stop : 'Stop',
            },
        },
        SecurityGroups : {
            searchHolder : 'Search for ID / Name',
            FirstColumn  : 'ID / Security Group Name',
            SecondColumn : 'Security Group ID',
            ThirdColumn : 'Security Group Name',
            FourthColumn : 'Tags',
            FifthColumn : 'Related Instances',
            SixthColumn : 'Creation Time',
            SeventhColumn : {
                title : 'Actions',
                Configure : 'Configure',
                Edit  : 'Modify',
                Delete : 'Delete',
                delcon : 'Please remove the related instance(s) before deleting security group.'
            },
            addSecurityGroups :{
                title : 'Create Security Group',
                title2 : 'Modify Security Group',
                name : 'Name',
                tags : 'Tags',
                description : 'Description',
                element1 : '2 to 64 characters in length',
                element2 : 'Separated by comma',
                Button1 : 'Cancel',
                Button2 : 'Confirm',
            },
            delSecurityGroups :{
                title : 'Delete Security Group',
                element1 : 'Are you sure to delete ?',
                element2 : 'To prevent your inter-instance network communication from being affected, please proceed with caution.',
                element3 : '',   
                element4 : 'selected',
                element5 : 'security groups',
                element6 : 'security group',
                Button1 : 'Cancel',
                Button2 : 'Delete',
            },
            Configurelist :{
                InboundRules : {
                    title : 'Inbound Rules',
                    FirstColumn  : 'ID / Security Group Name',
                    SecondColumn : 'Authorization Object',
                    ThirdColumn : 'Protocol Type',
                    FourthColumn : 'Port Range',
                    FifthColumn : 'Action',
                    SixthColumn : 'Description',
                    SeventhColumn : 'Priority',
                    Allowed : 'Allowed',
                    NotAllowed : 'Not Allowed',
                    EighthColumn : {
                        title : 'Actions',
                        modify : 'modify',
                        delete : 'delete',
                    },
                    addButton : {
                        title : 'Add Inbound Rule',
                        element1 : 'If an instance is added to a security group for the first time, all ports are denied by default. Please add permission  rules as needed.',
                        element2 : 'Source format: All IP (0.0.0.0),Single IP (10. x.x.y),IP segment (x.y.z.0 / 24),Multiple IP (10. x.y.z, 11. x.y.z, 12. x.y.z)',
                        element3 : 'Port format: Single port (22), Port range (10 / 20), All ports (- 1 / - 1)',
                        element4 : 'Priority: From 1 to 99, the smaller the number, the higher the priority.',
                        FirstColumn  : 'Protocol Type',
                        SecondColumn : 'Authorization Object',
                        ThirdColumn : 'Port Range',
                        FourthColumn : 'Action',
                        FifthColumn : 'Description',
                        SixthColumn : 'Priority',
                        SeventhColumn : 'Actions',
                        eg1 : 'eg:0.0.0.0/24',
                        eg2 : 'Please fill in',
                        eg3 : 'eg:1~99',
                        Button1 : 'delete',
                        Button2 : 'Add',
                        Button3 : 'Cancel',
                        Button4 : 'Confirm',
                    },
                    Button1 : '+Add Rule',
                    editButton : {
                        title : 'Modify Rule',
                        element1 : 'All IP (0.0.0.0),Single IP (10. x.x.y),IP segment (x.y.z.0 /24),Multiple IP (10. x.y.z, 11. x.y.z, 12. x.y.z)',
                        element2 : 'Please type the name of policy',
                        element3 : 'Single port (22), Port range (10 / 20), All ports (- 1 / - 1)',
                        element4 : 'From 1 to 99',
                        FirstColumn  : 'Protocol Type',
                        SecondColumn : 'Authorization Object',
                        ThirdColumn : 'Port Range',
                        FourthColumn : 'Action',
                        FifthColumn : 'Description',
                        SixthColumn : 'Priority',
                        SeventhColumn : 'Actions',
                        Button3 : 'Cancel',
                        Button4 : 'Confirm',
                    },
                    delButton : {
                        title : 'Delete Rule',
                        element1 : 'Are you sure to delete ?',
                        element2 : 'rules selected',
                        element3 : ' In order to avoid affecting the network communication between your instances, please operate carefully.',
                        element4 : ' Selected rules:',
                        Button3 : 'Cancel',
                        Button4 : 'Delete',
                    },
                },
                RelatedInstances : {
                    title : 'Related Instances',
                    empty : 'Please add an instance to a security group in the instance list',
                    FirstColumn  : 'Instance ID/Name',
                    SecondColumn : 'IP Address',
                    ThirdColumn : 'Zone',
                    FourthColumn : {
                        title : 'Actions',
                        removeout : 'Remove',
                    },
                    Button1 : 'Add Instances',
                    footer : {
                        title : 'Mass Actions',
                        Delete : 'Remove from Security Group',
                    },
                },
                AddSecurityGroup : {
                    title : 'Add into Security Group',
                    element1 : 'Selected Security Group',
                    element2 : 'Please search Name/ID/IP',
                    element3 : 'Instance ID/Name',
                    element4 : 'IP Address',
                    element5 : 'Intranet',
                    Button1 : 'Cancel',
                    Button2 : 'Confirm',
                },
                RemoveInt :{
                    title : 'Remove',
                    element1 : 'Are you sure to remove ',
                    element2 : ' instances from Security Group?',
                    element3 : ' ',
                    element4 : 'List of selected instance',
                    element5 : 'selected',
                    element6 : 'In order to avoid affecting the network communication between your instances, please operate carefully.',
                    Button1 : 'Cancel',
                    Button2 : 'Confirm',
                },
            },
            footer : {
                title : 'Mass Actions',
                Delete : 'Delete',
            },
        },
        IP : {
            searchHolder : 'Search for IP',
            FirstColumn  : 'IP',
            SecondColumn : {
                title : 'Status',
                Available : 'Available',
                // ToBeAssigned : 'To Be Assigned',
                // Unbound : 'Unbound',
                // Bound : 'Bound',
                Inuse : 'In Use',
                Disabled : 'Disabled',
                // Deleted : 'Deleted',
                Expired : 'Expired',
            },
            ThirdColumn : 'Zone',
            FourthColumn : 'Bound Server',
            FifthColumn : 'Bandwidth',
            SixthColumn : {
                title : 'Purchasing Method',
                // Unsold : 'Unsold',
                Package : 'Package',
                Separately : 'Independent',
            },
            SeventhColumn : 'Price ($ / mo)',
            EighthColumn : 'Validity Period',

            addip :{
                title : 'Add Reserved IP',
                element1 : 'Related Server',
                element2 : 'Please select a instance to mount',
                element3 : 'Quantity:',
                Charges : 'Price',
                Button1 : 'Cancel',
                Button2 : 'Pay',
            }
        },
        Intranets : {
            searchHolder : 'Search for Name',
            FirstColumn  : 'Zone',
            SecondColumn : 'Name',
            ThirdColumn : 'Creation Time',
            FourthColumn : {
                title : 'Actions',
                view : 'View',
                Edit : 'Edit'
            },
            viewlist : {
                title : 'Intranet',
                FirstColumn  : 'Zone',
                SecondColumn : 'Name',
                ThirdColumn : 'Configuration',
                FourthColumn : 'IP',
            },
            addpop : {
                title : 'Add Intranet',
                FirstColumn  : 'Intranet Name:',
                SecondColumn : 'Zone:',
                element1 : 'Each user can only set up one intranet in a zone',
                Button1 : 'Cancel',
                Button2 : 'Confirm',
            },
            editpop : {
                title : 'Edit Intranet',
            },
            element1 : 'Secure Isolation: ',
            element2 : 'Builds an isolated network environment based on Yisu Cloud. Layer-2 logical isolation is achieved between different intranets.',
            element3 : 'Flexibility: ',
            element4 : 'Software-defined network (SDN) configures the network as required, customizes the IP address range and route table.',
            element5 : 'Free of Charge:',
            element6 : 'Achieve a fully isolated intranet environment for free on the Yisu Cloud platform.',
            element7 : 'Application:',
            element8 : 'Bare Metal servers in one zone can access each other through intranets while those in different zones cannot.',
        },
        error : {
            renewpop:{
                error1 : 'Please enter the login password',
                error2 : 'Please wait for the price calculate out',
                error3 : 'Period must great than 0',
                error4 : 'Please select at least 1 instance',
            },
            startpop:{
                error1 : 'One or more instances can not be start',
            },
            restartpop:{
                error1 : 'One or more instances can not be restart',
            },
            stoppop:{
                error1 : 'One or more instances can not be stop',
            },
            buypop:{
                error1 : 'Please enter the login password',
                error2 : 'Create order fail!',
                error3 : 'Please select payment method!',
            },
        }
    }
}


// WEBPACK FOOTER //
// ./src/lang/en/bms.js